import { render, staticRenderFns } from "./issueList.vue?vue&type=template&id=7bab455e&"
import script from "./issueList.vue?vue&type=script&lang=ts&"
export * from "./issueList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports